module.exports = __webpack_public_path__ + "static/img/projectDetail_4.c27543f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectDetail_4.jpg
// module id = uWeo
// module chunks = 0